import { Injectable } from '@angular/core';
import { IndexedDBService } from '../indexed-db-service/indexed-db.service';
import * as moment from 'moment';
import { environment } from '../environments/environment';
import { EventService } from '../config-eventlogs/event.service';

@Injectable()
export class LoggerService {

  constructor(private _indexedDB: IndexedDBService,private _eventService: EventService) { }

  public debug(tag: string, msg: string) {
    if (environment.production) {
      // ignore this level of logs in 'production' until a log level is implemented
      return;
    }
    let momentDate = moment();
    console.debug(momentDate.format('DD/MM HH:mm:ss.SSS'), tag, msg);

    this._indexedDB.storeLog(momentDate.toDate(), tag, msg);
  }

  public log(tag: string, msg: string) {
    let momentDate = moment();
    console.log(momentDate.format('DD/MM HH:mm:ss.SSS'), tag, msg);

    this._indexedDB.storeLog(momentDate.toDate(), tag, msg);
  }

  public info(tag: string, msg: string) {
    let momentDate = moment();
    console.info(momentDate.format('DD/MM HH:mm:ss.SSS'), tag, msg);

    this._indexedDB.storeInfo(momentDate.toDate(), tag, msg);
  }

  public warn(tag: string, msg: string) {
    let momentDate = moment();
    console.warn(momentDate.format('DD/MM HH:mm:ss.SSS'), tag, msg);

    this._indexedDB.storeWarn(momentDate.toDate(), tag, msg);
  }

  public error(tag: string, msg: string) {
    let momentDate = moment();
    console.error(momentDate.format('DD/MM HH:mm:ss.SSS'), tag, msg);

    this._indexedDB.storeError(momentDate.toDate(), tag, msg);
  }

  public storeLogArray(type: string, msg: string) {
    let momentDate = moment();
    if (type === 'Error') {
      this._eventService.errorLogLength++;
   }
    this._indexedDB.resultArray.unshift({date:momentDate.toDate(),message :msg,type:type});
  }
}
